/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Trailer Door Status Icon component.
 */
export const TrailerDoorStatusIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.5736 6.00016H29.4452C29.5977 6.00014 29.7485 6.03141 29.8891 6.09214C30.0297 6.15287 30.1572 6.24185 30.2641 6.3539C30.371 6.46595 30.4552 6.59882 30.5118 6.74477C30.5684 6.89072 30.5963 7.04683 30.5938 7.20401V27.3661H9.4064V7.20401C9.40388 7.0452 9.43235 6.88749 9.49011 6.74025C9.54787 6.59302 9.63376 6.45927 9.74265 6.34696C9.85154 6.23465 9.98122 6.14607 10.124 6.08649C10.2667 6.02691 10.4196 5.99756 10.5736 6.00016V6.00016Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M14.7098 27.3662H9.41064V33.8186H14.7098V27.3662Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M30.5921 27.3662H25.293V34.0002H30.5921V27.3662Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M18.4458 23.8545H22.4143' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <line x1='15.0195' y1='30.4463' x2='24.9844' y2='30.4463' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default TrailerDoorStatusIcon;
